<template lang="pug">
  main.layout__main
    .container
      .loader.mt-0(v-if="!isReady")
      .grid.grid_h-center(v-else)
        .grid__col.grid__col_xl-20
          section.section.mt-0
            .section__item
              Breadcrumbs(:items="breadcrumbs")
            .section__item
              .full-width
                .container.container_mobile
                  .grid.grid_h-center.grid_v-margins
                    .grid__col.grid__col_lg-7.grid__col_xl-6
                      Nav(
                        :items="navItems"
                        itemsClass="d-none d-lg-block"
                      )
                        template(slot="beforeList")
                          a.club-info(
                            :href="champLink"
                            target="_blank"
                          )
                            .club-info__text
                              .text-lg.text-break: b {{ champ.Name }}
                              .text-sm.color-muted: b Страница чемпионата
                          .divider
                          .dropdown-container.d-lg-none
                            button.button.button_shadow.button_wide.button_flex.text-left(id="champsNavTrigger" style="height: 48px;")
                             span.button__icon
                              icon(:icon-name="activeNav.icon")
                             span.button__text.mr-auto {{ activeNav.name }}
                             span.button__icon.color-muted
                              icon(icon-name="down")
                            Dropdown(
                              triggerId="champsNavTrigger"
                              placement="bottom-end"
                              :hideOverlay="true"
                            )
                              template(slot="items")
                                .dropdown__item(v-for="item in navItems")
                                  .divider(v-if="item.isDivider")
                                  .dropdown__link(
                                    v-else=""
                                    :is="item.link ? 'router-link' : 'div'"
                                    :to="item.link ? item.link : null"
                                    @click.prevent="item.onClick"
                                  )
                                    .dropdown__icon
                                      icon(:icon-name="item.icon")
                                    span.dropdown__text {{ item.name }}
                    .grid__col.grid__col_lg-17.grid__col_xl-14
                      keep-alive
                        router-view(
                          :champ="champ"
                          @infoChanged="infoChanged"
                          @nominationsChanged="() => triggerChampsUpdate()"
                          @stagesChanged="() => triggerChampsUpdate()"
                        )
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Nav from '@/components/Nav'
import Select from '@/components/Select'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import { Skeleton } from 'vue-loading-skeleton'
import { find } from 'lodash'
import champsService from '@/services/champsService'

export default {
  name: 'ManageChamp',
  components: {
    Nav,
    Select,
    Breadcrumbs,
    Skeleton
  },
  data () {
    return {
      clubCode: null,
      champId: null,
      champ: {},
      nav: this.$route.name,
      isReady: false
    }
  },
  computed: {
    ...mapState('user', ['isAuthorized']),
    activeNav () {
      return find(this.navItems, (o) => o.id === this.nav)
    },
    navItems () {
      return [
        {
          id: 'EditChampInfo',
          name: 'Настройки',
          link: { name: 'EditChampInfo' },
          icon: 'settings'
        },
        {
          id: 'EditChampNominations',
          name: 'Номинации',
          link: { name: 'EditChampNominations' },
          icon: 'trophy'
        },
        {
          id: 'EditChampStages',
          name: 'Этапы',
          link: { name: 'EditChampStages' },
          icon: 'empty-flag'
        },
        {
          isDivider: true
        },
        {
          id: 'EditChampDelete',
          name: 'Удалить',
          link: null,
          icon: 'delete',
          onClick: this.deleteChamp
        }
      ]
    },
    mobileNavItems () {
      const items = []

      this.navItems.forEach((item) => {
        if (!item.isDivider) {
          items.push(item)
        }
      })

      return items
    },
    breadcrumbs () {
      if (!this.clubCode) {
        return []
      }
      return [
        {
          name: this.champ.Club.Name,
          link: {
            name: 'ManageClub',
            params: { id: this.clubCode }
          }
        },
        {
          name: 'Чемпионаты',
          link: {
            name: 'ManageChamps',
            params: { id: this.clubCode }
          }
        }
      ]
    },
    clubLink () {
      return {
        name: 'Club',
        params: { id: this.clubCode }
      }
    },
    champsLink () {
      return {
        name: 'ManageChamps',
        params: { id: this.clubCode }
      }
    },
    champLink () {
      return this.$getEnvVar('VUE_APP_CHAMPS_URL') + `Championship/${this.champ.Code}`
    }
  },
  methods: {
    ...mapActions('champs', ['triggerChampsUpdate']),
    infoChanged (data) {
      this.champ.StartDate = data.startDate
      this.champ.FinishDate = data.finishDate
      this.triggerChampsUpdate()
    },
    deleteChamp () {
      this.$root.confirmDialog(
        {
          title: 'Вы уверены, что хотите удалить чемпионат?',
          confirmText: 'Удалить'
        },
        () => {
          champsService.deleteChamp({
            champId: this.champId
          })
            .then((res) => {
              const data = res.data

              if (data.Success) {
                this.triggerChampsUpdate(true)
                this.$router.replace(this.champsLink)
              } else {
                this.addSomethingWrongAlert()
              }
            })
            .catch(() => {
              this.addSomethingWrongAlert()
            })
        }
      )
    },
    getChampInfo () {
      champsService.getChampInfo({ champId: this.champId })
        .then((res) => {
          const d = res.data
          if (d) {
            this.champ = d
            this.isReady = true
          } else {
            this.$router.replace(this.clubLink)
          }
        })
    }
  },
  watch: {
    $route (val) {
      this.nav = val.name
    }
  },
  mounted () {
    if (!this.isAuthorized) {
      this.$router.replace(this.champsLink)
      return
    }
    // this.getClubInfo(this.$route.params.id || this.$getTenantIdClub())
    this.getChampInfo()
  },
  created () {
    this.clubCode = this.$route.params.id || this.$getTenantIdClub()
    this.champId = this.$route.params.champId
  }
}
</script>

<style lang="scss" scoped>
  .club-info {
    display: flex;
    align-items: center;
    color: inherit;
    text-decoration: none;
    margin-bottom: 16px;
    transition: $transition-default color;

    .no-touch &:hover {
      color: $color-primary;
    }

    &__text {
      flex: 1 1 100%;
      min-width: 0;
    }
  }
</style>
